import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import { doTrack } from '../../helpers/TaggingSerializer'
import conf from '../../config/config'

import HelpLink from '../../components/HelpLink/HelpLink'
import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import FAQAccordions from '../../components/FAQAccordions/FAQAccordions'
import StarRating from '../../components/StarRating/StarRating'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import './ArgosCard.scss'

class ArgosCard extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('argos-card', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/argos-card/') {
        return callback()
      }

      dispatch(actions.fetchPageContent('argos-card'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props
    if (!sidebar.length) actions.fetchSidebarNav()
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:argoscard'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_argoscard'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { sidebar, page, error } = this.props
    const imgDir = conf.IMG_DIR + '/argos-card'

    if (!page || error) return <LoadingError />

    return (
      <div id='page-argoscard' className='helpfaq page page-argoscard'>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative lg-row'>
            <Sidebar activePage='/help/argos-card/' links={sidebar} sticky />
          </div>
        </div>

        <div className='argoscard-conent font-argos sticky-content'>

          <div className='afs-banner'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>

                  <div className='afs-banner__main xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <div className='afs-banner__title'>Everything you love from Argos today, with more time to pay.</div>
                      <div className='afs-banner__subtitle'>Representative <span className='font-compressed-bold'>29.9% APR</span> variable</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='afs-benefits'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <div className='afs-benefits__container xs-row'>
                    <div className='afs-benefits__benefit xs-12 md-4'>
                      <div className='tick' />
                      You can buy now and pay later
                    </div>
                    <span className='spacer' />
                    <div className='afs-benefits__benefit xs-12 md-4'>
                      <div className='tick' />
                      Flexible repayment options
                    </div>
                    <span className='spacer' />
                    <div className='afs-benefits__benefit xs-12 md-4'>
                      <div className='tick' />
                      Manage your card on the go
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='payments-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <h2 className='h2 section-title'>You decide which way you pay</h2>
                    </div>
                  </div>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <p>With an Argos Card, you can buy anything from us, start using it right away but pay us later.</p>
                      <p>Decorating your new home? Pre-ordering the latest PlayStation?</p>
                      <p>We've got a range of credit plans, from 3 to 12 months, depending on how much you spend. So you could buy yourself some extra time to pay for those bigger purchases.</p>
                      <p>It works like a standard credit card too – for anything under £50, you'll get until your next statement to pay. Ideal for your everyday shopping at Argos.</p>
                      <div className='xs-hidden md-block'>
                        <a href='/webapp/wcs/stores/servlet/ArgosFSCardBuyingToday?storeId=10151&langId=110&ddkey=ArgosFSCardHome' className='btn-hero' target='_blank'>Apply Now</a>
                      </div>
                      <div className='xs-block md-hidden'>
                        <a href='/webapp/wcs/stores/servlet/ApplyNowMobileView?storeId=10151' className='btn-hero' target='_blank'>Apply Now</a>
                      </div>
                      <h3 className='h3 section-subheading'>Once you've got your plan, it's up to you how you pay</h3>
                      <p>As long as your total credit plan is paid off in full and your account is kept up-to-date before the end date, you'll be charged no interest.</p>
                      <div className='xs-row xs-row--negative'>
                        <div className='xs-12 sm-4'>
                          <div className='tile monthly background-color-grey-light text-color-mauve'>
                            <div>
                              Make monthly payments
                            </div>
                          </div>
                        </div>
                        <div className='xs-12 sm-4'>
                          <div className='tile payments background-color-grey-light text-color-mauve'>
                            <div>
                              Different-sized payments at any time
                            </div>
                          </div>
                        </div>
                        <div className='xs-12 sm-4'>
                          <div className='tile balance background-color-grey-light text-color-mauve'>
                            <div>
                              The whole balance at the end
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className='font-base--small'>You won't be charged any interest if you pay off your plan within the Pay Later period and keep your account up to date. If you don't pay off your plan before it ends, you'll be charged interest at your normal plan rate from the date of purchase. However, if you choose to make payments without clearing the balance, the earlier you pay the less interest you'll be charged. Credit subject to status.</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='eligibility-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <h2 className='h2 section-title'>You can apply if you....</h2>
                    </div>
                  </div>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-6'>
                      <div className='argoscard-fancard' />
                      <ul className='list-unstyled list-ticks'>
                        <li>Are 18 or over</li>
                        <li>Can provide your bank details</li>
                        <li>Can provide your address for the past 2 years</li>
                        <li>Are a permanent UK resident for over 1 year</li>
                      </ul>
                      <p>Is your answer to the above 'yes, yes, yes, yes'? Then grab your bank details... You can check if you'll be accepted without affecting your credit rating, in just a few minutes.</p>
                      <div>
                        <a href='/webapp/wcs/stores/servlet/ArgosFSCardBuyingToday?storeId=10151&langId=110&ddkey=ArgosFSCardHome' className='btn-hero apply-link apply-link--desktop' target='_blank'>Apply Now</a>
                        <a href='/webapp/wcs/stores/servlet/ApplyNowMobileView?storeId=10151' className='btn-hero apply-link apply-link--mobile' target='_blank'>Apply Now</a>
                        <HelpLink href='/help/argos-card/credit-offers/' className='btn-hero'>View Current Credit Offers</HelpLink>
                      </div>
                      <h3 className='h3'>Not quite eligible for an Argos Card?</h3>
                      <p>Don't worry - we accept all these payment types aswell...</p>
                      <div className='cards'>
                        <img className='cards__card' src={`${imgDir}/cards/card-visa.png`} alt='Visa' />
                        <img className='cards__card' src={`${imgDir}/cards/card-mastercard.png`} alt='Mastercard' />
                        <img className='cards__card' src={`${imgDir}/cards/card-maestro.png`} alt='Maestro' />
                        <img className='cards__card' src={`${imgDir}/cards/card-american-express.png`} alt='American Express' />
                        <img className='cards__card' src={`${imgDir}/cards/card-paypal.png`} alt='PayPal' />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='apply-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-6'>
                      <h2 className='h2 section-title'>Get it today</h2>
                      <p>Got your eye on something already? You're in luck. You can buy it right away and we'll deliver it to your door. Here's how to apply and buy with an Argos Card today...</p>
                      <ol className='list-numbered'>
                        <li>Fill up your trolley and opt for delivery</li>
                        <li>Select Argos Card when you check out and apply</li>
                        <li>If you're accepted, we'll bring your order to you*</li>
                      </ol>
                      <p className='terms'>*Credit subject to status. Just for the first order we'll deliver to your home address for security reasons. Once you've got your Card you can shop how you want.</p>
                      <a href='//www.argos.co.uk/' className='btn-hero'>Keep Shopping</a>
                    </div>

                    <div className='xs-12 md-6'>
                      <h2 className='h2 section-title'>Plan ahead</h2>
                      <p>Not sure what you want yet? You can apply for an Argos Card now and decide later. Perfect for redecorating, welcoming a new addition to the family, or pre-ordering that new PlayStation.</p>
                      <ol className='list-numbered'>
                        <li>Apply for an Argos Card</li>
                        <li>We'll send you your Card within 10 days</li>
                        <li>Get set, go shopping - either online or in-store</li>
                      </ol>
                      <a className='terms-header' href='/webapp/wcs/stores/servlet/ArgosFSTermsConditionsView?storeId=10151&langId=110' target='_blank'>Terms & Conditions apply</a>
                      <div className='xs-hidden md-block'>
                        <a href='/webapp/wcs/stores/servlet/ArgosFSCardKillerQuestionsView?langId=110&storeId=10151&journeyType=applyOnly' className='btn-hero' target='_blank'>Apply Now</a>
                      </div>
                      <div className='xs-block md-hidden'>
                        <a href='/webapp/wcs/stores/servlet/ApplyForCreditMobileCmd?langId=110&storeId=10151&journeyType=applyOnly' className='btn-hero' target='_blank'>Apply Now</a>
                      </div>
                    </div>
                  </div>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <h2 className='h2 section-title'>Need a little help completing this form?</h2>
                      <p>We want to provide you with the right level of support throughout your application.</p>
                      <p>
                        If you need help in understanding what you are applying for, or want to inform us of anything that may affect your ability to understand
                        the application you are making today, please call us on <a className='help__telephone-link' href='tel:03452660988'>0345 266 0988</a>.
                        We’ll be able to discuss your needs &amp; offer suitable support.
                      </p>
                      <p>
                        Monday to Saturday: 9.00 – 17.00
                        <br />
                        Sunday: 10.00 – 16.00
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='container ask-tpl-container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12 lg-9 lg-3-offset content'>

                <div className='xs-row xs-row--negative'>
                  <div className='xs-12'>

                    <p className='font-base font-base--small'>Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker, and works exclusively with the Argos Card lender, Home Retail Group Card Services Limited.</p>

                    <FAQAccordions faqs={page.related_faqs} />

                    <StarRating pageId={page.id} />

                    <LiveChat
                      actions={this.props.actions}
                      chatHasEnded={this.props.chatHasEnded}
                      chatLoading={this.props.chatLoading}
                      chatOnline={this.props.chatOnline}
                    />

                    <SearchBar position='bottom' />

                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

ArgosCard.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArgosCard)
